import type { SettingsTabId } from "@/components/Templates/Settings/Settings.template.types";
import {
  INVITABLE_ROLE_KEYS,
  ROLE_NAME_ALIASES,
  SETTINGS_TAB_ACCESS,
  SHOP_ROLE_DEFINITIONS,
  type ShopRoleKey,
} from "./constants";

export function resolveRoleKeyFromRoleName(roleName: string): ShopRoleKey | null {
  const trimmed = roleName.trim();
  const lower = trimmed.toLowerCase();

  const direct = ROLE_NAME_ALIASES[trimmed] ?? ROLE_NAME_ALIASES[lower];
  if (direct) return direct;

  for (const [alias, key] of Object.entries(ROLE_NAME_ALIASES)) {
    if (lower.includes(alias.toLowerCase())) return key;
  }

  return null;
}

/** The per-store role wins; the global role is only a fallback when no membership is known yet. */
export function resolveShopRoleKey(roleName?: string, globalRoles?: string[]): ShopRoleKey {
  if (roleName) return resolveRoleKeyFromRoleName(roleName) ?? "operator";

  return globalRoles?.includes("owner") ? "owner" : "operator";
}

export function buildRoleIdMap(roles: { id: number; name: string }[]): Map<ShopRoleKey, number> {
  const map = new Map<ShopRoleKey, number>();

  roles.forEach((role) => {
    const key = resolveRoleKeyFromRoleName(role.name);
    if (key && key !== "owner") {
      map.set(key, role.id);
    }
  });

  return map;
}

export function getInvitableRoleDefinitions() {
  return INVITABLE_ROLE_KEYS.map((key) => getRoleDefinition(key));
}

export function getVisibleTabsForRole(roleKey: ShopRoleKey): SettingsTabId[] {
  if (roleKey === "operator") return [];

  return (Object.entries(SETTINGS_TAB_ACCESS) as [SettingsTabId, ShopRoleKey[]][])
    .filter(([, roles]) => roles.includes(roleKey))
    .map(([tab]) => tab);
}

export function getRoleDefinition(roleKey: ShopRoleKey) {
  return SHOP_ROLE_DEFINITIONS.find((role) => role.key === roleKey) ?? SHOP_ROLE_DEFINITIONS[0];
}
